import React,{useEffect, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { copyContent,emptyContent } from '../../Redux/Actions/formAction';
import { addContentInPlaylist } from '../../Redux/Actions/playlistAction';
import { getContent } from "../../Redux/Actions/contentAction";
import PrevNextPagination from "../../components/pagination/PrevNextPagination";
import styles from './tab.module.css';
import './tab-media.css';
import Image from './tabviews/images/Image';
import Url from './tabviews/url/Url';
import Video from './tabviews/videos/Video';
import PdfTab from './tabviews/pdf/PdfTab';
import Widget from './tabviews/widget/Widget';
import TemplateTab from './tabviews/template/TemplateTab';
import { useContextUserId } from "../../hooks/useSupportContext";
const tabs={
    image:Image,
    video:Video,
    url:Url,
    Pdf:PdfTab,
    widget:Widget,
    template:TemplateTab
}
function Tab(props) {
    const dispatch=useDispatch();
    const {contentForm,isContentAvailable}=useSelector(state=>state.Form);
    const {content, pagination}=useSelector(state=>state.Content);
    const {user}=useSelector(state=>state.User);
    const contextUserId = useContextUserId();
    const [type,setType]=useState('image');
    const [currentPage,setCurrentPage]=useState(1);
    const Component=tabs[type];
    useEffect(()=>{
     isContentAvailable &&  dispatch(emptyContent())   
    },[])
    useEffect(()=>{
        // keep form content in sync with currently loaded content page
        dispatch(copyContent(content));
    },[content, dispatch])
    // const emitOfAddContent=(mac)=>{
    //     const id=setTimeout(() => {
    //         props.socketRef.current?.emit('content_added',{detail:{mac:mac}})
    //         clearTimeout(id);
    //     }, 2000);
    //   }
 const submitContent=()=>{
   dispatch(addContentInPlaylist(contentForm));
//    console.log(props.screenMac)
//    if(props.screenMac!=="" || props.screenMac!==undefined){
//    emitOfAddContent(props.screenMac);
//    }
   props.close(false);
 }

 const resolveContentType = (tabType) => {
  switch(tabType){
    case 'Pdf':
      return 'application';
    default:
      return tabType;
  }
 };

 const handlePageChange = (page) => {
  setCurrentPage(page);
  const limit = pagination?.itemsPerPage || 10;
  const contentType = resolveContentType(type);
  if(contextUserId){
    dispatch(getContent(contextUserId,{page,limit,type:contentType}));
  }
 };
    return (
   <>
   <div className={`${styles.tabContainer} playlist-tab-root`}>
       <div className={`${styles.tabHeader}`}>
           <div className={`${styles.tabs}`}>
           <button
           className={`${styles.tabBtn} ${type==='image' ? styles.tabActive : ''}`}
            onClick={()=>setType('image')}>Image</button>
           <button
           className={`${styles.tabBtn} ${type==='video' ? styles.tabActive : ''}`}
            onClick={()=>setType('video')}>Video</button>
            <button
           className={`${styles.tabBtn} ${type==='url' ? styles.tabActive : ''}`}
            onClick={()=>setType('url')}>URL</button>
             <button
           className={`${styles.tabBtn} ${type==='Pdf' ? styles.tabActive : ''}`}
            onClick={()=>setType('Pdf')}>PDF</button>
             <button
           className={`${styles.tabBtn} ${type==='template' ? styles.tabActive : ''}`}
            onClick={()=>setType('template')}>Template</button>
             {/* <button
           className={`${styles.tabBtn} ${type==='widget' ? styles.tabActive : ''}`}
            onClick={()=>setType('widget')}>Widgets</button> */}
           </div>
          
       </div>
       <div className={`${styles.tabBody}`}>
           <div className={`${styles.innerBody}`}>
           <Component pId={props.pId}/>
           </div>
       </div>
       <div className={`${styles.tabFooter}`}>
          {pagination && (
            <PrevNextPagination
              pagination={pagination}
              onBack={(page)=>handlePageChange(page)}
              onNext={(page)=>handlePageChange(page)}
            />
          )}
          <button className='btn-cancel' onClick={()=>props.close(false)}>close</button>
          <button className='btn-save' onClick={submitContent}>Save</button>
       </div>
   </div>
   </>
  )
}

export default Tab